/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { Directive, Input } from '@angular/core';
let /** @type {?} */ nextUniqueId = 0;
/**
 * Single error message to be shown underneath the form field.
 */
export class MatError {
    constructor() {
        this.id = `mat-error-${nextUniqueId++}`;
    }
}
MatError.decorators = [
    { type: Directive, args: [{
                selector: 'mat-error',
                host: {
                    'class': 'mat-error',
                    'role': 'alert',
                    '[attr.id]': 'id',
                }
            },] },
];
/**
 * @nocollapse
 */
MatError.ctorParameters = () => [];
MatError.propDecorators = {
    'id': [{ type: Input },],
};
function MatError_tsickle_Closure_declarations() {
    /** @type {?} */
    MatError.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatError.ctorParameters;
    /** @type {?} */
    MatError.propDecorators;
    /** @type {?} */
    MatError.prototype.id;
}
//# sourceMappingURL=error.js.map